import { Navigate, useLocation } from "react-router";
import isAuthenticated from "./isAuthenticated";
import { canAccessRoute } from "../../config/routes";

export const RequireAuth = ({ children }) => {
	const auth = isAuthenticated();
	const location = useLocation();

	// Not logged in - redirect to sign in
	if (!auth.token) {
		const requestedRoute = `${location.pathname}${location.search}${location.hash}`;
		sessionStorage.setItem("postAuthRedirect", requestedRoute);
		return <Navigate to="/SignIn" state={{ from: location }} replace />;
	}

	// Parse access into array
	const accessStr = auth.access || "";
	const userAccess = accessStr
		.split(",")
		.map((a) => a.trim())
		.filter(Boolean);

	// Check if user can access this route
	if (canAccessRoute(location.pathname, userAccess)) {
		return children;
	}

	// User is authenticated but doesn't have access to this specific route
	// Redirect to home or show unauthorized
	return <Navigate to="/" state={{ from: location }} />;
};
